import { Alert, Button, CircularProgress, InputBase, LinearProgress, Typography } from "@mui/material";
import { Box, textTransform } from "@mui/system";
import React, { useEffect, useState } from "react";
import { styled } from "@mui/system";
import { ErrorOutline, PlaceRounded } from "@mui/icons-material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import planlist from '../plans.json' 
import posthog from "posthog-js";
const Billing = () => {
  console.log(planlist)
  const [plan, setPlan] = useState(null)
  const [loader, setLoader] = useState(true);
  const [error_msg, setErrorMsg] = useState(null);
  const navigate = useNavigate()
  const [product_key, setProductKey] = useState('')

const [successMsg, setSuccessMsg] = useState(null)
  const getProductkey = async () => {
    setErrorMsg(null)

      let check= await axios.post(`${process.env.REACT_APP_BACKEND_URL}get-user-by-id`,{
                      userId: JSON.parse(localStorage.getItem('user')).userId.S
                  });
                  
                  if (check.status ===  200) {
                    const user___ = check.data.user;
                    
              
                    if(user___.relatedOrgs.L?.find((e)=> e?.M.org_id?.S ===  JSON.parse(localStorage.getItem('organization')).orgId.S)){
                        
                      try {
                        setLoader(true)
                        let key = await axios.post(
                          process.env.REACT_APP_BACKEND_URL + "productkey/redeem-product-key",
                          {
                            keyId: product_key,
                            relatedAccount:  JSON.parse(localStorage.getItem("organization"))
                            .orgId.S
                          }
                        );
                  
                  
                  
                  
                        setLoader(false);
                       
                  
                        console.log({key})
                  
                  
                          if(key && key.data.updatedProductKey){
                            setLoader(true);
                            let organization = await axios.post(
                              process.env.REACT_APP_BACKEND_URL + "stripe/subscription-to-secret-plan",
                              {
                                customer_id: JSON.parse(localStorage.getItem("organization")).subscription_details.M.stripe_cust_id.S,
                              organization_id: JSON.parse(localStorage.getItem("organization"))
                                .orgId.S,
                                price : key.data.updatedProductKey.planId
                               
                              }
                            );
                  
                            localStorage.setItem('organization', JSON.stringify(organization.data.organization))
                  
                  
                            let organization_ = await axios.post(
                              process.env.REACT_APP_BACKEND_URL + "productkey/add-product-key",
                              {
                                keyId: product_key,
                              organization_id: JSON.parse(localStorage.getItem("organization"))
                                .orgId.S,
                               
                              }
                            );
                  
                  
                            localStorage.setItem('organization', JSON.stringify(organization_.data.organization))
                  
                  
                            console.log(organization_)
                  
                  
                  
                  
                  
                            console.log(organization)
                  
                           
                  
                  
                  
                  
                  
                            check_subscription()
                            setProductKey("")
                            setSuccessMsg("Product key redeemed successfully")
                            setTimeout(() => {
                              setSuccessMsg(null)
                            }, 3000);
                            setLoader(false);
                          }
                       
                        return;
                      } catch (error) {
                        console.log(error);
                        if (error.response && error.response.data) {
                          console.error("Response data:", error.response.data);
                          setErrorMsg(error.response.data.message);
                        }
                        setLoader(false);
                      }
                    }else{
                      window.location.reload()
                    }
          
                  }
  };


  const manage_billing = async () => {
    posthog.capture('Clicked the "manage billing" button', {
      email: JSON.parse(localStorage.getItem('user')).email.S,
userId : JSON.parse(localStorage.getItem('user')).userId.S,
    });
      let check= await axios.post(`${process.env.REACT_APP_BACKEND_URL}get-user-by-id`,{
                      userId: JSON.parse(localStorage.getItem('user')).userId.S
                  });
                  
                  if (check.status ===  200) {
                    const user___ = check.data.user;
                    
              
                    if(user___.relatedOrgs.L?.find((e)=> e?.M.org_id?.S ===  JSON.parse(localStorage.getItem('organization')).orgId.S)){
                        
                      try {
                        setLoader(true)
                        let organization = await axios.post(
                          process.env.REACT_APP_BACKEND_URL + "stripe/manage-billing",
                          {
                            customer_id: JSON.parse(localStorage.getItem("organization")).subscription_details.M.stripe_cust_id.S,
                            organization_id: JSON.parse(localStorage.getItem("organization"))
                              .orgId.S,
                          }
                        );


                        window.location.href = organization.data.url
                  
                        setLoader(false);
                       
                        
                        return;
                      } catch (error) {
                        console.log(error);
                        if (error.response && error.response.data) {
                          console.error("Response data:", error.response.data);
                          setErrorMsg(error.response.data.message);
                        }
                        setLoader(false);
                      }
                    }else{
                      window.location.reload()
                    }
          
                  }
  
  };


  const check_subscription = async () => {
     try {
       setLoader(true)
       let sub = await axios.post(
         process.env.REACT_APP_BACKEND_URL + "stripe/check-subscription",
         {
           customer_id: JSON.parse(localStorage.getItem("organization")).subscription_details.M.stripe_cust_id.S,
           sub_id: JSON.parse(localStorage.getItem("organization")).subscription_details.M.stripe_sub.S,
         }
       );

       console.log(sub.data)

       console.log(planlist[sub.data?.planDetails[0].plan_id])
       setPlan(sub.data)
       return;
     } catch (error) {
       console.log(error);
       if (error.response && error.response.data) {
         console.error("Response data:", error.response.data);
         setErrorMsg(error.response.data.message);
       }
       setLoader(false);
     }
  };

  const [calls, setCalls] = useState([]);

  const getCalls = async () => {
    setLoader(true);
    try {
      let calls_ = await axios.post(
        process.env.REACT_APP_BACKEND_URL + "call/get-calls",
        {
          organization_id: JSON.parse(localStorage.getItem("organization"))
            .orgId.S,
        }
      );
      let calls__ = calls_.data.calls;
      let formattedCalls = calls__.map((call) => ({
        callTime: call.startTime?.N || "N/A", // Use "N/A" if callTime is missing
        toNumber: call.toNumber?.S || "N/A", // Fallback to "N/A" if toNumber is missing
        callerNumber: call.fromNumber?.S || "N/A", // Fallback
        action: call.action?.S || "N/A", // Fallback
        actionDetails: call.actionDetails?.S || "N/A", // Fallback
        voicemail: call.voicemail?.S || "No", // Default to "No"
        link: "/dashboard/call-details/" + call.callId?.S, // Default link
      }));
      console.log(formattedCalls);
      setCalls(formattedCalls);

      setLoader(false);
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        console.error("Response data:", error.response.data);
        setErrorMsg(
          error.response.data.error + " " + error.response.data?.message
        );
      }
      setLoader(false);
    }
  };


  const getProductKeys = async () => {

  let sub = await axios.post(
      process.env.REACT_APP_BACKEND_URL + "productkey/get-product-keys",
      
    );
    console.log(sub.data)
  }

  useEffect(() => {
    getCalls();
    getProductKeys()
    
    check_subscription()
  }, []);


    const [users_data, setUsersData] = useState(
      JSON.parse(localStorage.getItem("organization")).users.L
    );
    const [users, setUsers] = useState([]);
    const fetchUsers = async () => {
      let users_data =  JSON.parse(localStorage.getItem("organization")).users.L
      if (users_data) {
        setLoader(true)
        const fetchedUsers = await Promise.all(
          users_data.map(async (item) => {
            try {
              const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}get-user-by-id`,
                { userId: item.M.userId.S } // Extract userId from item
              );
  
              // Extract and map the necessary information]
              setLoader(false)
              return {
                name: `${response.data.user.fName.S} ${response.data.user.lName.S}`,
                email: response.data.user.email.S,
                userType: item.M?.type?.S, // Extract userType from item
                status: item.M.status.S, // Extract status from item
                user_id: response.data.user.userId.S, // Extract userId
              };
            } catch (error) {
              console.error("Error fetching user:", error);
              return null; // Handle the error gracefully
              setLoader(false)
            }
          })
        );
  
        // Filter out any null responses and update the state
        setUsers(fetchedUsers.filter((user) => user !== null));
        console.log('fet',fetchedUsers.filter((user) => user !== null))
      }
    };
  
    useEffect(() => {
     
      fetchUsers();
      console.log('users', users)
    }, [users_data]);


    const filterCallsByMonth = (calls) => {
      // Get the current date
      const now = new Date();
    
      // Calculate the start of the current month
      const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1).getTime();
    
      // Calculate the end of the current month (last day of the month)
      const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0).getTime();
    
      // Filter calls by callTime within the current month's range
      const filteredCalls = calls.filter((call) => {
        const callTime = call.callTime; // Assuming callTime is in milliseconds
        return callTime >= startOfMonth && callTime <= endOfMonth;
      });
    
      return filteredCalls;
    };
    
   
    const callsThisMonth = filterCallsByMonth(calls);
    console.log(callsThisMonth);
    

  return (
    <div className="text-[#030229]  px-3 lg:px-0 py-4 lg:py-0">
   

      {
        (users && users.filter((e)=> e.email ===  JSON.parse(localStorage.getItem('user')).email.S)[0]?.userType  !== 'user'  )? (
         <>
          {successMsg && (
       <Alert severity="success" >
       {successMsg}
     </Alert>
    )}
      {error_msg && (
        <div className="text-center text-red-500 lg:text-[13px] text-[12px] mt-2  font-semibold ">
          <ErrorOutline sx={{ fontSize: "" }} /> {error_msg}
        </div>
      )}

      {/* {loader && (
        <div className="flex justify-center">
         <CircularProgress size={"1.2rem"}   sx={{ color: "#605BFF", animationDuration: "0.7s", }} />
        </div>
      )} */}
      <div className="lg:text-[16px] text-[14px] font-[500] mb-4">
        Current Plan: {!loader && plan ? (planlist[plan?.planDetails[0].plan_id]).planName  : <CircularProgress
         size={"1rem"}   sx={{ color: "#605BFF", 
position:'relative',
top: 3,
left: 1,
         
         animationDuration: "0.7s", }} /> }

        {!loader && plan?.subscriptionStatus ===  'trialing' && (
          <span style={{textTransform:'capitalize'}} className="capitalize bg-[rgba(91,147,255,0.1)] text-[#5B93FF] py-1 px-3 text-[14px] rounded-full ml-2">{ plan?.subscriptionStatus}</span>
        )}

{!loader && plan?.subscriptionStatus ===  'active' && (
          <span style={{textTransform:'capitalize'}} className="capitalize bg-[rgba(58,151,76,0.1)] text-[#3A974C] py-1 px-3 text-[14px] rounded-full ml-2">{ plan?.subscriptionStatus}</span>
        )}


{ (!loader && plan && plan?.subscriptionStatus !== 'trialing' && plan?.subscriptionStatus !== 'active')  && (
          <span style={{textTransform:'capitalize'}} className="capitalize bg-[rgba(174,180,193,0.1)] text-gray-500 py-1 px-3 text-[14px] rounded-full ml-2">{ plan?.subscriptionStatus}</span>
        )}
      </div>

      <div className="lg:w-[400px] w-full mb-5">
        <ProgressBarWithLabel value={filterCallsByMonth(calls)?.length} max={plan && (planlist[plan?.planDetails[0].plan_id]).monthlyCalls} />
      </div>
        <div className="space-y-3 mb-5 ">
        <div className="lg:text-[16px] text-[14px] font-[500] ">
          Login to Stripe to Manage Billing.
        </div>

        <div className="lg:text-[14px] text-[12px] pb-4 ">
          Make sure to use {JSON.parse(localStorage.getItem("user")).email.S} to login to the billing
          console. Need to update the billing admin? Contact Support at
          hello@twilanswer.com
        </div>

        <div className=" ">
          <Button
            sx={{
              textTransform: "none",
              bgcolor: "#605BFF",
              color: "white",
              py: { lg: "6px", xs: "5px" },
              px: "20px",
              borderRadius: "12px",
              fontSize: { lg: "14px", xs: "12px" },
              height: "fit",
            }}

            onClick={manage_billing}
            disabled={loader}
          >
           {loader ? (
        <div className="flex justify-center">
          <CircularProgress size={"1.2rem"} sx={{ color: "white" }} />
        </div>
      ): 'Manage Billing'}
          </Button>
        </div>
      </div>

      <div className="space-y-3 ">
        <div className="lg:text-[16px] text-[14px] font-[500] underline ">
          Product Key
        </div>

        <div className="lg:text-[14px] text-[12px]  ">
          If you have a product key from one of our partners, you can enter it
          below.
        </div>

        <div className="lg:flex items-center lg:space-x-3 space-y-3 lg:space-y-0 ">
          {/* <div className="lg:text-[14px] text-[12px]  font-[500] ">key</div> */}

          <InputBase
            value={product_key}
            onChange={(e)=> {
              setProductKey(e.target.value)
            }}
            sx={{
              bgcolor: "#F7F7F8",
              width: { lg: "321px", xs: "100%" },
              px: 2,
              fontSize: { lg: "14px", xs: "13px" },
            }}
          />
          <Button
            sx={{
              textTransform: "none",
              bgcolor: "#605BFF",
              color: "white",
              py: { lg: "4px", xs: "4px" },
              px: "1px",
              borderRadius: "12px",
              fontSize: { lg: "14px", xs: "12px" },
              height: "fit",
            }}

            onClick={()=> getProductkey()}
          >
            Save
          </Button>
        </div>
      </div>
        </>
        ): (
          <Alert color='warning'>
            <div className=" text-black-600 text-[14px] ">
         You can't view this page in this organization because your type is user
        </div>
          </Alert>
        )
      }

      
    </div>
  );
};

// Custom styles for LinearProgress
const CustomLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 20,
  borderRadius: 12,
  backgroundColor: "#f4f4f4", // Light gray background
  "& .MuiLinearProgress-bar": {
    borderRadius: 12,
    backgroundColor: "#a2f5a2", // Light green progress color
  },
}));

const ProgressBarWithLabel = ({ value, max }) => {
  const progress = (value / max) * 100; // Calculate progress percentage

  return (
    <Box display="flex" alignItems="center" gap={1}>
      {/* Progress Bar */}
      <Box sx={{ flexGrow: 1 }}>
        <CustomLinearProgress variant="determinate" value={progress} />
      </Box>
      {/* Label */}
      <div className="lg:text-[14px] text-[12px] font-[500]">
        {value}/{max} Calls
      </div>
    </Box>
  );
};

export default Billing;
